const navLinks = [
    {
        label: "APLIKACJA",
        href: "/application"
    },
    {
        label: "REGULAMIN",
        href: "/rules"
    },
    {
        label: "LORE",
        href: "/lore"
    },
    {
        label: "FRAKCJE",
        href: "/fractions"
    },
    {
        label: "FAQ",
        href: "/faq"
    },
    {
        label: "WSPARCIE",
        href: "/donate"
    },
    {
        label: "DISCORD",
        target: '_blank',
        href: "https://discord.com/invite/humanityrp"
    },
]

export default navLinks